export const sidePolicyIcon = (size: number) => (
	<svg width={size} height={size} viewBox="0 0 26 23" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M11 0C9.90625 0 9 0.90625 9 2V3H6V2H4V3H2C0.90625 3 0 3.90625 0 5V21C0 22.0938 0.90625 23 2 23H24C25.0938 23 26 22.0938 26 21V5C26 3.90625 25.0938 3 24 3H22V2H20V3H17V2C17 0.90625 16.0938 0 15 0H11ZM11 2H15V3H11V2ZM2 5H24V21H22V6H20V21H6V6H4V21H2V5Z"
			fill="black"
		/>
	</svg>
);
